"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./ChevronIcon.sass");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ChevronIcon = function ChevronIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'up' : _ref$type;
  var mainClassName = (0, _classnames.default)({
    'Chevron-up': type === 'up',
    'Chevron-left': type === 'left',
    'Chevron-right': type === 'right'
  });
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: mainClassName,
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.9999 7.4999C14.5116 7.0116 13.7199 7.01164 13.2316 7.49999L9.99989 10.7324L6.76815 7.49999C6.27989 7.01164 5.48818 7.0116 4.99988 7.4999C4.51158 7.9882 4.51161 8.77989 4.99994 9.26815L9.99989 14.2674L14.9998 9.26815C15.4882 8.77989 15.4882 7.9882 14.9999 7.4999Z",
    fill: color
  }));
};

ChevronIcon.propTypes = {
  type: _propTypes.default.oneOf(['up', 'down', 'left', 'right']).isRequired
};
var _default = ChevronIcon;
exports.default = _default;